// C.1: общий реестр реализованных способностей и warn-логика для всех фракций.
//
// До C.1 этот файл лежал отдельно в global/ и livlife/, с дублированием
// state. Объединил в один файл с единым реестром _implemented (Set).
//
// Использование в файлах способностей:
//   import { registerImplementedAbility } from '../warn-unimplemented.js';
//   export function ...(state) { ... }
//   registerImplementedAbility('global_mit', 'active', 'trigger');
//
// Использование в загрузчике карт (вызовы при выставлении/розыгрыше):
//   warnUnimplementedAbilities(card)            — авто по card.faction
//   warnUnimplementedGlobalAbilities(card)      — backward-compat
//   warnUnimplementedLivLifeAbilities(card)     — backward-compat

const _warned = new Set();
const _implemented = new Set();

const ABILITY_FIELDS = [
  'passive', 'order', 'active', 'trigger',
  'deathrattle', 'aura', 'oneshot', 'summon'
];

const FACTIONS_REQUIRING_WARN = new Set(['global', 'livlife']);

export function registerImplementedAbility(cardId, ...fields) {
  for (const f of fields) _implemented.add(`${cardId}|${f}`);
}

export function isAbilityImplemented(cardId, field) {
  return _implemented.has(`${cardId}|${field}`);
}

// Унифицированный варн-проход. Сам определяет фракцию.
export function warnUnimplementedAbilities(card) {
  if (!card) return;
  if (!FACTIONS_REQUIRING_WARN.has(card.faction)) return;
  const at = card.ability_text;
  if (!at || typeof at !== 'object') return;
  for (const f of ABILITY_FIELDS) {
    const val = at[f];
    if (val == null || val === '') continue;
    const key = `${card.id}|${f}`;
    if (_warned.has(key)) continue;
    if (_implemented.has(key)) continue;
    _warned.add(key);
    console.warn(`[Корпы] карта ${card.id}: способность ${f} не реализована, пропущена`);
  }
}

// Backward-compat алиасы — оставлены чтобы не править все импорты разом.
export function warnUnimplementedGlobalAbilities(card) {
  if (!card || card.faction !== 'global') return;
  warnUnimplementedAbilities(card);
}

export function warnUnimplementedLivLifeAbilities(card) {
  if (!card || card.faction !== 'livlife') return;
  warnUnimplementedAbilities(card);
}

// Только для тестов.
export function _resetWarnCacheForTests() {
  _warned.clear();
}

// Алиас для совместимости с прошлым именем в livlife/.
export function _resetLivLifeWarnCacheForTests() {
  _warned.clear();
}
